(function () {
  'use strict';
  // Localization is initialized independently of the drawer/animation features.
  document.querySelectorAll('.eo-language').forEach(function (form) {
    var select = form.querySelector('[name="language_code"]');
    if (!select) return;
    select.addEventListener('change', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(form);
    });
  });
  var shell = document.querySelector('.eo-shell');
  var menu = document.getElementById('ElmiraMenu');
  if (!shell || !menu) return;
  var toggle = shell.querySelector('.eo-menu-toggle');
  function resetMenu() {
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('eo-menu-open');
    toggle.focus();
  }
  function closeMenu() {
    if (typeof menu.close === 'function') menu.close();
    else { menu.removeAttribute('open'); resetMenu(); }
  }
  toggle.addEventListener('click', function () {
    if (typeof menu.showModal === 'function') menu.showModal();
    else { menu.setAttribute('open', ''); menu.classList.add('eo-menu-fallback'); }
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('eo-menu-open');
    menu.querySelector('.eo-close').focus();
  });
  menu.querySelector('.eo-close').addEventListener('click', closeMenu);
  menu.addEventListener('close', resetMenu);
  menu.addEventListener('click', function (event) {
    if (event.target !== menu) return;
    var bounds = menu.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right) closeMenu();
  });
  document.addEventListener('keydown', function (event) {
    if (!menu.hasAttribute('open')) return;
    if (event.key === 'Escape') closeMenu();
    if (event.key === 'Tab') {
      var focusable = menu.querySelectorAll('a[href],button,select,input');
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  window.addEventListener('resize', function () { if (window.innerWidth >= 1040 && menu.hasAttribute('open')) closeMenu(); });
  var messages = shell.querySelectorAll('.eo-message');
  var pause = shell.querySelector('.eo-pause');
  if (!pause || !messages.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var index = 0, paused = reduced.matches, timer;
  function stop() { clearInterval(timer); }
  function start() {
    stop();
    if (paused || document.hidden || messages.length < 2) return;
    timer = setInterval(function () {
      messages[index].classList.remove('is-current');
      messages[index].setAttribute('aria-hidden', 'true');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-current');
      messages[index].removeAttribute('aria-hidden');
    }, 6000);
  }
  function state() {
    pause.setAttribute('aria-pressed', String(paused));
    pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause);
    pause.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
    start();
  }
  pause.addEventListener('click', function () { paused = !paused; state(); });
  var announcement = shell.querySelector('.eo-announcement');
  announcement.addEventListener('mouseenter', stop);
  announcement.addEventListener('mouseleave', start);
  announcement.addEventListener('focusin', stop);
  announcement.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', start);
  function motionChanged() { paused = reduced.matches; state(); }
  if (reduced.addEventListener) reduced.addEventListener('change', motionChanged);
  else if (reduced.addListener) reduced.addListener(motionChanged);
  state();
})();
